import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-machine-tools/HeroSection';
import { IntroSection } from './spinner-machine-tools/IntroSection';
import { TurningCentersSection } from './spinner-machine-tools/TurningCentersSection';
import { MillingSection } from './spinner-machine-tools/MillingSection';
export function SpinnerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3999">
      <SeoBar data-id="element-4000" />
      <Header data-id="element-4001" />
      <main className="flex-grow" data-id="element-4002">
        <div className="w-full bg-white pb-20" data-id="element-4003">
          <HeroSection data-id="element-4004" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4005">
            <IntroSection data-id="element-4006" />
            <TurningCentersSection data-id="element-4007" />
            <MillingSection data-id="element-4008" />
            <hr className="border-gray-200" data-id="element-4009" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4010" />
    </div>;
}